<template>
  <div class="news">
    <img
      src="../../assets/imgs/policy_guidelines/header.png"
      alt=""
    />
    <div class="crumbs">
      <img
        class="home"
        src="../../assets/imgs/policy_guidelines/home.png"
        alt=""
      >
      <span class="mySize">
        <span
          style="color: #595959; cursor: pointer;"
          @click="goIndex()"
        >首页&gt;</span>
        <span
          style="color: #595959; cursor: pointer;"
          @click="goGuide()"
        >政策指南&gt;</span>
        <span>最新政策</span>
      </span>
    </div>
    <div class="main">
      <h1>{{detail.title}}</h1>
      <div class="tit-info mySize">
        <div class="time">
          <img
            class="icon"
            src="../../assets/imgs/policy_guidelines/clock.png"
            alt=""
          >发布日期：
          <span>{{$moment(detail.releaseTime).format("YYYY-MM-DD HH:MM:SS")}}</span>
        </div>
      </div>
      <div
        v-html="detail.remark"
        class="mySize"
      ></div>
      <div
        class="pdf_box"
        v-for="(item,index) in fileList"
        :key="index"
      >
        <img src="../../assets/imgs/policy_guidelines/pdf_icon.png" />
        <a
          :href="baseUrl + item.path"
          target="_blank"
        >{{item.name}}</a>
      </div>
      <div class="button_box">
        <el-button
          type="primary"
          plain
          @click="back()"
        >返 回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as guideApi from '@/api/guidelines'
export default {
  data () {
    return {
      id: '',
      detail: {},
      fileList: [],
    };
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getData();
    }

  },
  methods: {
    //获取指南详情
    async getData () {
      let param = {
        id: this.id
      }
      const res = await guideApi.getGuideDetail(this.sendParam(param));
      let result = this.paramDecrypt(res)
      if (result.code == 200) {
        this.detail = result.data
        this.fileList = result.data.fileVo
      } else {
        this.$message.error(result.msg);
      }
    },
    //去首页
    goIndex () {
      this.$router.push({
        path: "index",
      })
    },
    //去政策指南
    goGuide () {
      this.$router.push({
        path: "policy_guidelines",
      })
    },
    //返回上一页
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
ul li {
  list-style: none;
}
a {
  text-decoration: none;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #f3f3f3;
  img {
    width: 100%;
    height: auto;
  }
  .crumbs {
    width: 1100px;
    margin: 0 auto 10px auto;
    .home {
      width: 18px;
      height: 18px;
      margin-right: 5px;
      margin-top: 3px;
    }
  }
  .main {
    background: #fff;
    width: 1100px;
    min-height: 486px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    padding: 20px 75px;
    box-sizing: border-box;
    h1 {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .tit-info {
      margin: 0 !important;
      border-bottom: 1px solid #f1f1f1;
      text-align: center;
      .time {
        margin-bottom: 12px;
        .icon {
          width: 14px;
          height: 14px;
          margin-right: 5px;
          margin-top: 3px;
        }
      }
    }
    .pdf_box {
      background: #edf4fb;
      border: 1px solid #e7e7e7;
      border-radius: 6px;
      width: 100%;
      height: 40px;
      padding: 0 15px;
      margin-bottom: 60px;
      margin-top: 60px;
      box-sizing: border-box;
      display: flex;
      img {
        width: 20px;
        height: 22px;
        margin-top: 10px;
      }
      a {
        color: #000;
        font-size: 13px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        margin-left: 15px;
      }
    }
    .button_box {
      text-align: center;
    }
  }
}
</style>
